<template>
  <component :is="siteLayout">
    <router-view :key="$route.fullPath" />
  </component>
</template>

<script>
import SiteLayoutDefault from "@/components/SiteLayoutDefault";
import SiteLayoutPlain from "@/components/SiteLayoutPlain";

export default {
  name: "App",
  components: {
    SiteLayoutDefault,
    SiteLayoutPlain
  },

  computed: {
    siteLayout() {
      var defaultLayout = "SiteLayoutDefault";
      return this.$route.meta.pageLayout || defaultLayout;
    }
  },
  /* Imortant IE 11 fix for vue router to make "/#/..." or any other regular links work
   * Other workaround is to use router-link everywhere */
  mounted: function () {
    // fix for IE 11
    if (!!window.MSInputMethodContext && !!document.documentMode) {
      window.addEventListener("hashchange", this.hashChangeHandler);
    }
  },
  destroyed: function () {
    // fix for IE 11
    if (!!window.MSInputMethodContext && !!document.documentMode) {
      window.removeEventListener("hashchange", this.hashChangeHandler);
    }
  },
  methods: {
    hashChangeHandler: function () {
      var target = window.location.hash;
      this.$router.push(target.substring(1, target.length));
    }
  }
};
</script>

<style>

.v-application {
  font-size: 14px;
}

a {
  text-decoration: none !important;
}

.content-panel {
  padding: 40px 48px 40px 48px;
}

.ueberplus {
  font-size: 36px !important;
  font-weight: 400;
  line-height: 60px !important;
  letter-spacing: normal !important;
  padding-bottom: 0;
  padding-top: 0;
}

/* Standard Überschrift und main button text*/
.ueber {
  font-size: 24px !important;
  font-weight: 400;
  line-height: 32px !important;
  letter-spacing: normal !important;
}

.ueber2 {
  font-size: 16px !important;
  font-weight: 400;
  line-height: 24px !important;
  letter-spacing: normal !important;
}

h1 {
  font-size: 24px !important;
  font-weight: 400;
  line-height: 32px !important;
  letter-spacing: normal !important;
  padding-bottom: 12px;
  padding-top: 12px;

  display: block;
  -webkit-margin-before: 0;
  -webkit-margin-after: 0;
  -webkit-margin-start: 0;
  -webkit-margin-end: 0;
}

h2 {
  font-size: 16px !important;
  font-weight: 600;
  line-height: 24px !important;
  letter-spacing: normal !important;
  padding-bottom: 12px;
  padding-top: 12px;
  color: #0085CF;
  display: block;
  -webkit-margin-before: 0;
  -webkit-margin-after: 0;
  -webkit-margin-start: 0;
  -webkit-margin-end: 0;
}

.subueber {
  font-size: 20px !important;
  font-weight: 400;
  letter-spacing: normal !important;
}

.v-btn {
  /*get rid of UpperCase Buttons*/
  text-transform: none !important;
  letter-spacing: normal;
}

.semanticsection {
  padding-left: 0;
  padding-right: 0;
  padding-top: 28px;
  padding-bottom: 28px;
  background-color: white;
  min-height: 160px;
}

.semanticsection-title {
  padding-left: 0;
  padding-right: 0;
  padding-top: 0;
  padding-bottom: 0;
  background-color: white;
  font-size: 24px !important;
  font-weight: 400;
  margin-bottom: 22px !important;
  margin-top: 30px !important;
}

.container.grid-list-sm {
  padding: 0 !important;
}

.semanticsection-title2 {
  padding-left: 0;
  padding-right: 0;
  padding-top: 0;
  padding-bottom: 0;
  background-color: white;
  font-size: 24px !important;
  font-weight: 400;
  margin-bottom: 40px !important;
  margin-top: 56px !important;
}
.semanticsection-title3 {
  padding-left: 0;
  padding-right: 0;
  padding-top: 0;
  padding-bottom: 0;
  background-color: white;
  font-size: 24px !important;
  font-weight: 400;
  margin-bottom: 16px !important;
  margin-top: 56px !important;
}

.semanticsection-title.first, .semanticsection-title2.first {
  margin-top: 0 !important;
}

.standard-button {
  font-size: 16px!important;
  font-weight: 400!important;
}

.dmb-form-text {
  font-size: 16px !important;
}

.align--center {
  display: flex;
  align-items: center;
}

.align-top-rb {
  padding-top: 0 !important;
}

.align-top-rb-box {
  line-height: 24px;
  /*adjust line-heigt 24px; to label inside the rb control were line-height: 30px*/
  padding-top: 3px;
  /*padding like Textboxes */
  padding-right: 48px;
}

.align-top-rb-line {
  padding-bottom: 16px;
}

.bg-primary {
  background-color: #0085CF;
}

.bg-white {
  background-color: white;
}

.bg-dimmed {
  background-color: #f5f5f5 !important;
}

.round-corners {
  border-radius: 3px;
}

.v-application .black87, .v-application .theme--light.v-card.black87 > .v-card__text {
  color: rgba(0, 0, 0, .87) !important;
}

.v-input:not(.v-radio) {
  margin-top: 0;
  margin-bottom: 16px;
}

.v-input .input-group--text-field {
  padding-right: 48px !important;
}

.no-errors-group .input-group__details {
  display: none;
}

.no-errors-group .show-errors .input-group__details {
  display: flex !important;
}

.v-stepper__content, .v-stepper__wrapper {
  -webkit-transition: none !important;
  transition: none !important;
}

.v-application .theme--light.v-input:not(.v-input--error) label, .theme--light .v-input:not(.v-input--error) label {
  color: #4a4a4a;
}

.v-application .theme--light.v-input--selection-controls .v-icon-, .theme--light .v-input--selection-controls .v-icon {
  color: #4a4a4a;
}

.v-application .theme--light.v-input:not(.v-input--error) .v-input__details:before, .theme--light .v-input:not(.v-input--error) .v-input__details:before {
  background-color: #4a4a4a;
}

.v-application .theme--light.v-input:not(.v-input--error) .v-input__messages, .theme--light .v-input:not(.v-input--error) .v-input__messages {
  color: #4a4a4a;
}

.v-input--selection-controls {
  margin-top: 0!important;
}

/*ripple effect disabled application wide!*/
.v-input--selection-controls__ripple {
  display: none;
}

.no--scrolling {
  overflow-y: hidden;
}

.v-data-table table {
  border-collapse: collapse!important;
}

.v-data-table tbody tr:not(:last-child) {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12)!important;
}

.v-data-table tbody tr td:nth-child(n) {
  border-bottom: none!important;
}

.no--hover.v-data-table tbody tr:hover {
  background-color: transparent !important;
}

.no--hover.v-data-table tbody tr {
  cursor: initial;
}

.v-application .row {
  max-width: 100%;
}

.required .v-label:after {
  content: "*";
  text-decoration: inherit;
  vertical-align: inherit;
}

.v-input--radio-group--column .v-radio {
  margin-bottom: 0!important;
}

.v-input--radio-group__input .v-radio:not(:last-child) {
  margin-right: 80px!important;
}

.fill-parent, .fill-parent .v-input__control {
  width: 100% !important;
  min-width: 100% !important;
}

.v-input.short-input {
  max-width: 80px !important;
  padding-top: 0;
}

.v-input.short-input .v-text-field__details {
  overflow: visible;
}

.v-input.short-input .v-messages__message {
  white-space: nowrap;
}

.dmb-link, .dmb-link .v-icon {
  color: #002C76;
  font-size: 16px;
  text-decoration: none;
}

.dmb-link:hover, .dmb-link:hover .v-icon{
  text-decoration: none;
  color: #0085CF;
}

.dmb-link-underline:hover {
  text-decoration: underline;
}

.kompex-text {
  color: #077484!important;
}

.kompex-bg {
  background-color: #077484!important;
  color: white!important;
}

@media only screen and (min-width: 600px) {
  .v-snack__wrapper {
    max-width: 700px!important;
  }
}

.dmb-nowrap {
  white-space: nowrap;
  overflow: hidden;
  display: block;
  max-width: 100%;
  text-overflow: ellipsis;
}

.dmb-inline-nowrap {
  white-space: nowrap;
  overflow: hidden;
  max-width: 100%;
  text-overflow: ellipsis;
}
.spacepadding {
  padding-right: 4px;
}

</style>

